export const addProgress=(items, currentPage)=>{
    
    //console.log("addProgress", items.length, currentPage)
    const indexedPage = currentPage-1;
    
    for (let i = 0; i < items.length; i++) {
        //console.log(`Index: ${i}`,indexedPage); 
       
        //set visited
        if(i < indexedPage){
            items[i].status = "visited"
            items[i].percentageComplete = 100
        }else if(i === indexedPage){
            items[i].status = "current"
            items[i].percentageComplete = 0

        }
        else{
            items[i].status = "unvisited"
            items[i].percentageComplete = 0
        }   
        //initial state should be visited
        if(i == 0){
            items[i].status = "visited"
        }     
    }
    return items
}